import { isForecastOverTargetNotification } from "../../../components/Shared/forecastOverTargetNotification";
import { hashCell } from "./util";
import setGroupingWithNotifications from "./util/setNotifications/setGroupingWithNotifications";

const clearForecastOverTargetWarning = (dynamicModel, cellId) => {
  const {
    lookups: { cellLookup },
  } = dynamicModel;

  const cell = cellLookup[cellId];
  if (!cell || !isForecastOverTargetNotification(cell.notification)) {
    return dynamicModel;
  }

  cell.notification = {};

  setGroupingWithNotifications(cell.lineItem.grouping, dynamicModel.columns, {
    recalcChildren: false,
    recalcParents: true,
  });

  hashCell(cell, {
    rehashParents: true,
  });

  return dynamicModel;
};

export default clearForecastOverTargetWarning;
